
import { OrdersSliceState } from '../../slices/orders-slice';
import { OrdersDataState } from '../../slices/orders/orders-data-slice';
import { CreateOrderItemData } from './create-order-item-data';
import { VisibleConditionValueGetter } from '../../manager/visible-condition-value-getter';
import { checkEditable, checkOptional } from './item-detail-item-data';

const categorize = (v: string) => `商品情報-商品詳細-オプション-${v}`;
export const optionItemData = (order: OrdersSliceState, data: OrdersDataState, visibleCondition: VisibleConditionValueGetter): CreateOrderItemData[] => {
  // const display = genuineOrderDisplayItem(order, data);
  const displays = visibleCondition.optionOrderDisplay;
  const arr: CreateOrderItemData[] = [];
  displays.forEach((display, i) => {
    const {
      tag,
      item,
      quantity,
      cover,
      descriptionLocations,
      foilStamping,
      leafText1,
      leafText2
    } = order.option[i];
    const laminate = cover?.laminate?.value;
    if (item?.value) {
      arr.push(
        {
          name: 'tag',
          value: tag?.value,
          editable: checkEditable(display.itemTag),
          optional: checkOptional(display.itemTag),
          display: Boolean(display.itemTag),
          categorize: categorize('商品タグ'),
        },
        {
          name: 'item',
          value: item?.value,
          editable: checkEditable(display.item),
          optional: checkOptional(display.item),
          display: Boolean(display.item),
          categorize: categorize('商品'),
        },
        {
          name: 'quantity',
          value: String(quantity),
          editable: checkEditable(display.quantity),
          optional: checkOptional(display.quantity),
          display: Boolean(display.quantity),
          categorize: categorize('数量'),
        },
        // {
        //   name: 'descriptionLocations',
        //   value: ,
        //   editable: checkEditable(display),
        //   optional: checkOptional(display),
        //   display: Boolean(display),
        //   categorize: categorize(''),
        // },
        {
          name: 'laminate',
          value: laminate,
          editable: checkEditable(display.laminate),
          optional: checkOptional(display.laminate),
          display: Boolean(display.laminate && data.option.optionLaminate[i]?.laminate?.length),
          categorize: categorize('表紙-ラミ選択'),
        },
        {
          // 表紙加工
          // 後加工情報が有効かつカバーIDが特定の値の場合に表示
          //  L 商品IDが選択された場合に後加工情報を取得
          //  L 商品選択が選択された場合にカバーIDを取得
          // 自動表紙加工情報がある場合に内部的に分岐
          //  L 表紙色情報が設定された時に取得？（SQLの条件句にop01_coverColor_pre_select）
          name: 'leafColor',
          value: foilStamping?.value ?? '',
          editable: checkEditable(display.leafColor),
          optional: checkOptional(display.leafColor),
          display: Boolean(display.leafColor && !!foilStamping?.value),
          categorize: categorize('表紙加工'),
        },
        {
          // 箔押し文字1
          // 表紙加工が特定の値の場合に表示。表紙加工記載の最初の条件のみ適用
          name: 'leafText1',
          value: leafText1,
          editable: checkEditable(display.leafText1),
          optional: checkOptional(display.leafText1),
          display: Boolean(display.leafText1 && !!foilStamping?.value),
          categorize: categorize('箔押し文字1'),
          validation: (v) => (v ?? '').length <= 24,
        },
        {
          // 箔押し文字2
          // 表紙加工が特定の値の場合に表示。表紙加工記載の最初の条件のみ適用
          name: 'leafText2',
          value: leafText2,
          editable: checkEditable(display.leafText2),
          optional: checkOptional(display.leafText2),
          display: Boolean(display.leafText2 && !!foilStamping?.value),
          categorize: categorize('箔押し文字2'),
          validation: (v) => (v ?? '').length <= 24,
        },
      );
    }
  });
  return arr;
}
